export default __webpack_public_path__ + "static/char-15-d5e1b5b14291f14f55009d715d39563d.gif";